<template>
  <label
    :aria-checked="model === label"
    :aria-disabled="isDisabled"
    class="s-radio"
    :class="[
      { 'is-disabled': isDisabled },
      { 'is-readonly': readonly },
      { 'is-bordered': border },
      { 'is-checked': model === label }
    ]"
    :data-qa="dataQa"
    role="radio"
    :tabindex="tabIndex"
    @keydown.space.stop.prevent="model = readonly || isDisabled ? model : label">
    <span
      class="s-radio__input"
      :class="{'is-checked': model === label}">
      <span class="s-radio__inner"/>
      <input
        ref="radio"
        v-model="model"
        aria-hidden="true"
        class="s-radio__original"
        :data-qa="`${dataQa}-radio`"
        :disabled="readonly || isDisabled"
        :name="name"
        :state="model === label ? 'check' : 'uncheck'"
        tabindex="-1"
        type="radio"
        :value="label"
        @blur="focus = false"
        @change="handleChange"
        @focus="focus = true">
    </span>
    <span
      class="s-radio__label"
      :data-qa="`${dataQa}-label`"
      @keydown.stop>
      <slot/>
      <template v-if="!$slots.default">{{ label }}</template>
    </span>
  </label>
</template>
<script>
import Form from '../../mixins/form.js'
import emitter from '../../mixins/emitter'

/**
 * Стандартный Radio
 * @displayName Radio
 */
export default {
  name: 'sRadio',
  mixins: [emitter, Form],
  componentName: 'sRadio',
  props: {
    /**
     * Значение
    */
    value: {
      type: [String, Number, Boolean],
    },
    /**
     * значение при использовании внутри группы
    */
    label: {
      type: [String, Number, Boolean],
    },
    /**
     * отключение
     */
    disabled: {
      type: Boolean,
    },
    /**
     * Только чтение
     */
    readonly: {
      type: Boolean,
    },
    /**
     * собственный атрибут 'name'
     * @ignore
     */
    name: {
      type: String,
    },
    /**
     * нужно ли добавлять рамку
     */
    border: {
      type: Boolean,
    },
    /**
     * Ключ для автотестов
     * @ignore
     */    
    dataQa: {
      type: String,
      default: 'input'
    }
  },
  data() {
    return {
      focus: false
    }
  },
  computed: {
    isGroup() {
      let parent = this.$parent
      while (parent) {
        if (parent.$options.componentName !== 'sRadioGroup') {
          parent = parent.$parent
        } else {
          return parent
        }
      }
      return false
    },
    model: {
      get() {
        return this.isGroup ? this.isGroup.value : this.value
      },
      set(val) {
        if (this.isGroup) {
          this.dispatch('sRadioGroup', 'input', [val])
        } else {
          this.$emit('input', val)
        }
        this.$refs.radio && (this.$refs.radio.checked = this.model === this.label)
      }
    },
    isDisabled() {
      return this.isGroup
        ? this.isGroup.disabled || this.disabled || (this.sForm || {}).disabled
        : this.disabled || (this.sForm || {}).disabled
    },
    tabIndex() {
      return (this.readonly || this.isDisabled || (this.isGroup && this.model !== this.label)) ? -1 : 0
    }
  },
  methods: {
    handleChange() {
      this.$nextTick(() => {
        this.$emit('change', this.model)
        this.isGroup && this.dispatch('sRadioGroup', 'handleChange', this.model)
      })
    }
  }
}
</script>